import SearchInputController from './search-input.controller';
import { SearchInputProps } from './search-input.model';

const SearchInput = (props: SearchInputProps) => {
  return <SearchInputController {...props} />;
};

export default SearchInput;
